import React from "react";

import LiveRegie from "../live/LiveRegie";
import useLiveRegie from "../live/useLiveRegie";

import type { JSX } from "react";

function ContentLive(): JSX.Element {
  const regie = useLiveRegie();

  return <LiveRegie regie={regie} />;
}

export default ContentLive;
